import React from 'react';
import './MusicForm.css';

function MusicForm({ form, onChange, onSubmit, isSubmitting }) {
  return (
    <div className="form-container">
      <input
        name="music_name"
        placeholder="Music Name"
        value={form.music_name}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <button onClick={onSubmit} disabled={isSubmitting}>
        {isSubmitting ? 'Saving...' : 'Save Music'}
      </button>
    </div>
  );
}

export default MusicForm;
